const tsApi = {
  customExpressList: '/v2/web/order/customExpressList', // 承运商-非系统通知物流承运商列表
  courierListStatus: '/v2/web/order/courierListStatus', // 非系统通知返回订单信息
  orderCourierUpdate: '/v2/web/order/orderCourierUpdate', // 系统通知转非系统通知
  courierStatusQuery: '/v2/web/order/courierStatusQuery', // 物流状态
  saveNotSystemLogisticsByOrder: '/v2/web/order/saveNotSystemLogisticsByOrder' // 工厂保存物流信息
}
export default tsApi



// WEBPACK FOOTER //
// ./src/service/basic/ts.js